import DropdownMenu from './dropdownMenu';
import DropdownItem from './dropdownItem';

const Dropdown = {
  Menu: DropdownMenu,
  Item: DropdownItem,
};

export default Dropdown;